import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 700,
  },

  filtersWrapper: {
    display: 'flex',
  },

  productAssociationsTable: {
    '& td': {
      textAlign: 'left',

      '&:first-of-type': {
        width: '30%',
      },
    },
  },

  descriptionChip: {
    fontSize: '10px',
    margin: theme.spacing(0.25),
    borderRadius: '0',
    color: theme.palette.white.main,
    background: theme.palette.secondary.main,
    border: 'none',
  },
}));

export default useStyles;
